import { ApiInspectionsV1LoadsListStatus } from 'api';

import { formatLoadStatus } from '../../utils/formatLoadStatus';

export const TIME_FILTER_FIELD_NAME = 'estimated_collection_time';
export const LOADS_STATUS_OPTIONS = Object.values(ApiInspectionsV1LoadsListStatus).map((status) => ({
  label: formatLoadStatus(status),
  value: status,
}));
